import { getAttachmentType } from './attachments';
import { DOWNLOAD_METHODS } from '../consts';
import type { Attachment } from '../types';

export const handleNonViewableAttachment = (params: {
  attachment: Attachment;
  openPDFAttachmentInNewTab: (data: { attachmentId: string }) => void;
  downloadAttachment: (data: { attachmentId: string; method: string }) => void;
}): void => {
  const { attachment, openPDFAttachmentInNewTab, downloadAttachment } = params;
  const isPDF = getAttachmentType(attachment.fileName) === 'pdf';

  if (isPDF) {
    openPDFAttachmentInNewTab({
      attachmentId: attachment.attachmentId,
    });
  } else {
    downloadAttachment({
      attachmentId: attachment.attachmentId,
      method: DOWNLOAD_METHODS.CLICK,
    });
  }
};
